export default {
  namespaced: true,
  state: {
    notifications: [],
  },
  mutations: {
    PUSH(state, notification) {
      state.notifications.push({
        ...notification,
        id: state.notifications.length + 1
      });
    },
    DELETE(state, notificationToRemove) {
      state.notificatios = state.notificatios.filter(
        notification => notification.id != notificationToRemove.id
      );
    },
    RESET(state){
      state.notifications = []
    }
  },
  actions: {
    add({ commit }, notification) {
      commit("PUSH", notification);
    },
    remove({ commit }, notificationToRemove) {
      commit("DELETE", notificationToRemove);
    },
    reset({commit}){
      commit("RESET")
    }
  }
};
